import { cn } from "@homeinstead/ui";

type CheckBadgeProps = {
  /** Merged onto the badge's circle, which is Night Sky by default. */
  className?: string;
};

/**
 * Selected single-choice badge. Its enter and draw animations finish within
 * the single-choice auto-advance delay, so the check is complete before the
 * step changes. Hidden from assistive tech; the radio carries the
 * selected state.
 */
function CheckBadge({ className }: CheckBadgeProps) {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute top-1/2 right-[7px] -translate-y-1/2"
      data-testid="lead-flow-check-badge"
    >
      <span
        className={cn(
          "flex size-10 items-center justify-center rounded-full bg-night-sky-base motion-safe:animate-selection-checkmark-enter motion-reduce:animate-none",
          className,
        )}
      >
        <svg className="size-10" fill="none" viewBox="0 0 40 40">
          <path
            className="stroke-white motion-safe:animate-selection-checkmark-draw motion-reduce:animate-none"
            d="M14 23.2667L18 27L27 13"
            pathLength={1}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
      </span>
    </span>
  );
}

export { CheckBadge };
